export default __webpack_public_path__ + "static/media/aws.8b55c8b7.png";